var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "container content-padding" }, [
      _c("div", { staticClass: "row justify-content-md-center" }, [
        _c("div", { staticClass: "col-6" }, [
          _c(
            "a",
            {
              staticStyle: { color: "#00BCD4" },
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.backToLogin.apply(null, arguments)
                }
              }
            },
            [_c("i", { staticClass: "fas fa-2x fa-arrow-left" })]
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row justify-content-md-center mt-5" }, [
        _c("div", { staticClass: "col-md-6 text-center" }, [
          _c("h3", [_vm._v("Partner OTP Verification")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Enter OTP sent to "),
            _c("span", { staticStyle: { "text-decoration": "underline" } }, [
              _vm._v(_vm._s(_vm.emailSentOtp))
            ])
          ]),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "digit-group form-otp",
              attrs: {
                "data-group-name": "digits",
                "data-autosubmit": "true",
                autocomplete: "off"
              },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submitOtp.apply(null, arguments)
                }
              }
            },
            [
              _c("input", {
                attrs: {
                  type: "text",
                  maxlength: "1",
                  id: "digit-1",
                  name: "digit-1",
                  "data-next": "digit-2",
                  required: ""
                }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  type: "text",
                  maxlength: "1",
                  id: "digit-2",
                  name: "digit-2",
                  "data-next": "digit-3",
                  required: "",
                  "data-previous": "digit-1"
                }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  type: "text",
                  maxlength: "1",
                  id: "digit-3",
                  name: "digit-3",
                  "data-next": "digit-4",
                  required: "",
                  "data-previous": "digit-2"
                }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  type: "text",
                  maxlength: "1",
                  id: "digit-4",
                  name: "digit-4",
                  "data-next": "digit-5",
                  required: "",
                  "data-previous": "digit-3"
                }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  type: "text",
                  maxlength: "1",
                  id: "digit-5",
                  name: "digit-5",
                  "data-next": "digit-6",
                  required: "",
                  "data-previous": "digit-4"
                }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  type: "text",
                  maxlength: "1",
                  id: "digit-6",
                  name: "digit-6",
                  "data-next": "digit-7",
                  required: "",
                  "data-previous": "digit-5"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "row mt-5" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("p", [
                    _vm._v("Don't receive the OTP ?\n                "),
                    _c(
                      "a",
                      {
                        class: { "disabled-resend": _vm.isDisabledResendOtp },
                        staticStyle: { color: "#00BCD4" },
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.resendOTP.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                  RESEND OTP\n                "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.timeLeftResendOTP < 30 && _vm.timeLeftResendOTP > 0
                    ? _c(
                        "p",
                        {
                          staticClass: "text-muted",
                          staticStyle: { "font-size": "14px" }
                        },
                        [
                          _vm._v(
                            "\n                Can be resend in " +
                              _vm._s(_vm.timeLeftResendOTP) +
                              " seconds.\n              "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row", staticStyle: { "margin-top": "5rem" } },
                [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button-large button-block -cyan",
                        attrs: {
                          id: "submit-otp",
                          disabled: _vm.isSubmittingOtp,
                          type: "submit"
                        }
                      },
                      [_vm._v(_vm._s(_vm.verifyTextButton))]
                    )
                  ])
                ]
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row text-center mt-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("img", {
          staticClass: "img-fluid",
          staticStyle: { height: "85px" },
          attrs: { src: "/static/img/logo.png", alt: "logo" }
        })
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76c0477c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76c0477c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partner/SendPartnerOTP.vue
// module id = 2367
// module chunks = 0